import React from 'react'
import { Box, Flex, Icon, styled, Text } from '@chilipiper/design-system'
import { UnstyledButton, LinkButton } from '@chilipiper/design-system/src/new'

interface Props {
  active?: boolean
  icon: React.ComponentType
  name: string
  onClick: () => void
  onConnect?: () => void
  showConnect?: boolean
}

interface StyledLocationCardProps {
  active?: boolean
}

export const LocationCard = ({ active, icon, name, showConnect, onConnect, onClick }: Props) => {
  return (
    <Box position='relative'>
      <UnstyledButton onClick={onClick} w='100%'>
        <StyledLocationCard
          alignItems='center'
          justifyContent='center'
          px={6}
          borderRadius={8}
          active={active}
        >
          <Flex flexDirection='column' alignItems='center' justifyContent='center' h='138px'>
            <Icon icon={icon} w={7} h={7} mb={3} color='fg/moderate' />
            <Text textStyle='body-monoline' color='fg/major' textAlign='center'>
              {name}
            </Text>
            {showConnect && <Box h={4} mt={4} />}
          </Flex>
        </StyledLocationCard>
      </UnstyledButton>
      {showConnect && (
        <StyledFlex position='absolute' bottom='23px' left='50%'>
          <LinkButton variant='minor' onClick={onConnect}>
            Connect
          </LinkButton>
        </StyledFlex>
      )}
    </Box>
  )
}

const StyledLocationCard = styled(Flex)<StyledLocationCardProps>`
  transition: all 0.2s;
  box-shadow: ${({ theme, active }) =>
    active ? theme.shadows['border/card-item-selected'] : theme.shadows['border/section']};
  background: ${({ theme, active }) =>
    active ? theme.colors['bg/list-item-selected'] : theme.colors['bg/list-item-default']};
  &:hover {
    box-shadow: ${({ theme, active }) =>
      active
        ? theme.shadows['border/card-item-selected']
        : theme.shadows['border/card-item-hovered']};
  }
`

const StyledFlex = styled(Flex)`
  transform: translateX(-50%);
`
